export const printables = {
  concept_map: {
    printableFileName: 'TinybopSchoolsPrintables_General_ConceptMap.pdf',
  },
  generating_questions: {
    printableFileName:
      'TinybopSchoolsPrintables_General_GeneratingQuestions.pdf',
  },
  weather_water_cycle: {
    printableFileName: 'TinybopSchoolsPrintables_Weather_TheWaterCycle.pdf',
  },
  weather_cold_warm: {
    printableFileName:
      'TinybopSchoolsPrintables_Weather_ColdWeatherandWarmWeather.pdf',
  },
  weather_journal: {
    printableFileName: 'TinybopSchoolsPrintables_Weather_WeatherJournal.pdf',
  },
  simple_machines_pulley: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_PulleyExperiment.pdf',
  },
  simple_machines_screw: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_ScrewExperiment.pdf',
  },
  simple_machines_lever: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_LeverExperiment.pdf',
  },
  simple_machines_wedge: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_WedgeExperiment.pdf',
  },
  simple_machines_wheel_axle: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_WheelsandAxlesExperiment.pdf',
  },
  simple_machines_inclined_plane: {
    printableFileName:
      'TinybopSchoolsPrintables_SimpleMachines_InclinedPlaneExperiment.pdf',
  },
  earth_weathering: {
    printableFileName:
      'TinybopSchoolsPrintables_TheEarth_WeatheringErosionandDeoposition.pdf',
  },
  skyscrapers_notebook: {
    printableFileName:
      'TinybopSchoolsPrintables_Skyscrapers_UniversalDesignerNotebook.pdf',
  },
  space_visit: {
    printableFileName: 'TinybopSchoolsPrintables_Space_MyVisittoOuterSpace.pdf',
  },
  space_comparing_planets: {
    printableFileName: 'TinybopSchoolsPrintables_Space_ComparingPlanets.pdf',
  },
  homes_day_life: {
    printableFileName: 'TinybopSchoolsPrintables_Homes_ADayintheLife.pdf',
  },
  homes_makes_house_home: {
    printableFileName:
      'TinybopSchoolsPrintables_Homes_WhatMakesaHouseaHome.pdf',
  },
  homes_comparing_homes: {
    printableFileName: 'TinybopSchoolsPrintables_Homes_ComparingHomes.pdf',
  },
  thb_inside: {
    printableFileName:
      'TinybopSchoolsPrintables_TheHumanBody_WhatsGoingonInsideyourBody.pdf',
  },
  thb_senses: {
    printableFileName:
      'TinybopSchoolsPrintables_TheHumanBody_ExerciseyourSenses.pdf',
  },
  thb_digestive: {
    printableFileName:
      'TinybopSchoolsPrintables_TheHumanBody_ExploretheDigestiveSystem.pdf',
  },
  mammals_animal_diets: {
    printableFileName: 'TinybopSchoolsPrintables_Mammals_AnimalDiets.pdf',
  },
  mammals_body_systems: {
    printableFileName: 'TinybopSchoolsPrintables_Mammals_MammalBodySystems.pdf',
  },
  coralreef_food_web: {
    printableFileName: 'TinybopPrintables_CoralReefFoodWeb.pdf',
  },
  coralreef_food_chains: {
    printableFileName: 'TinybopPrintables_CoralReef_FoodChains.pdf',
  },
  coralreef_investigate: {
    printableFileName: 'TinybopPrintables_CoralRef_InvestigateReefAnimal.pdf',
  },
  som_chocolate_experiment: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_ChocolateExperiment.pdf',
  },
  som_sorting: {
    printableFileName: 'TinybopSchoolsPrintables_StatesOfMatter_Sorting.pdf',
  },
  som_scavenger_hunt: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_ScavengerHunt.pdf',
  },
  som_thermometers: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_Thermometors.pdf',
  },
  som_molecular_behavior: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_MolecularBehavior.pdf',
  },
  som_observable_properties: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_ObservableProperties.pdf',
  },
  som_phase_changes: {
    printableFileName:
      'TinybopSchoolsPrintables_StatesOfMatter_PhaseChanges.pdf',
  },
};
